import { useSession } from 'context/Session'
import { useEffect } from 'react'

import * as S from './ValueProposition.styles'
import { doViewValueProposition } from '../modules/datasource'

const defaultProps = {}
const propTypes = {}

export const ValueProposition = () => {
  const { user, accessToken, setSession } = useSession()

  useEffect(() => {
    if (user && !user?.viewedValueProposition) {
      doViewValueProposition({ accessToken })
      setSession({ ...user, viewedValueProposition: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, accessToken])

  return (
    <S.Container>
      <S.FirstPanel />
      <S.SecondPanel />
      <S.ThirdPanel />
      <S.FourthPanel />
    </S.Container>
  )
}

ValueProposition.defaultProps = defaultProps
ValueProposition.propTypes = propTypes

export default ValueProposition
